import create from "zustand";

export const useCart = create((set) => ({
  cartItems: [],

  addItemToCart: (cartItem) =>
    set((state) => ({ cartItems: [...state.cartItems, cartItem] })),
  // increasePopulation: () => set((state) => ({ bears: state.bears + 1 })),
}));
